import { render, staticRenderFns } from "./HomeSkeleton.vue?vue&type=template&id=4b384def&scoped=true"
import script from "./HomeSkeleton.vue?vue&type=script&lang=js"
export * from "./HomeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HomeSkeleton.vue?vue&type=style&index=0&id=4b384def&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b384def",
  null
  
)

export default component.exports